// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageReveal_container__Zyy8j","imageWrapper":"ImageReveal_imageWrapper___UYaF","image":"ImageReveal_image__WMWb5","textWrapper":"ImageReveal_textWrapper__keCu4"};